import { findFirstOccurrence, propAccessor } from '@hc-frontend/utils'
import moneyFormat from 'utils/format/money'
import getPremium from 'core/controllerPlans/getPremium'
import getValueFees from 'core/controllerPlans/getValueFees'
import { VISION } from 'core/constants/products'
import { getExternalPlanTotal } from 'utils/plans/parseExternalBenefits'

function updatePlanPrices(state, planId) {
  const plan = state.plans[planId]

  if (!plan) {
    return {}
  }

  const toMoney = moneyFormat

  if (plan.multiCarrierPlan) {
    const firstDuration = plan.durations?.[0]
    if (!firstDuration) return {}
    const monthly = firstDuration.monthly
    const fees: Fee[] = monthly.fees || []
    const subscriptionFee = getValueFees('Application Fee', fees, 0)
    const premium = monthly.premium
    return {
      plan: toMoney(premium),
      planNumber: premium,
      dentalVision: toMoney(0),
      latitude: toMoney(0),
      total: toMoney(premium),
      bigTotal: toMoney(premium + subscriptionFee),
      subscriptionFee: toMoney(subscriptionFee),
      subscriptionFeeNumber: subscriptionFee,
      externalPlan: toMoney(0)
    }
  }

  const durations = propAccessor(plan, 'durations', {})
  const period = durations[state.period]

  const defaultPeriod =
    period[state.recurrence ? state.recurrence : Object.keys(period)[0]]

  const monthly = propAccessor(defaultPeriod, 'monthly', {})
  const fees: Fee[] = propAccessor(monthly, 'fees', [])

  const premium = propAccessor(monthly, 'premium', 0)
  const latitudeCost = getPremium(state.plans[state.latitudeId])
  const addonsByPlan = state.addonsByPlan[state.planId]

  const subscriptionFee = getValueFees('Application Fee', fees, 0)

  let visionDentalCost = getPremium(state.plans[state.dentalPlanId])

  if (state.dentalPlanId && !(state.hasDentalActive || state.hasVisionActive)) {
    state.visionPlanId = findFirstOccurrence(addonsByPlan, state.plansByType[VISION])
    visionDentalCost += getPremium(state.plans[state.visionPlanId])
  }

  const selectedBenefitLevels =
    state.selectedBenefitLevels || state.hcStorage?.selectedBenefitLevels || {}
  const selectedExternalPlans =
    state.addonsExternalByPlan[state.planId]?.length > 0
      ? state.addonsExternalByPlan[state.planId]
      : state.externalPlanSelected
      ? [state.externalPlanSelected]
      : []
  const externalPlanCost =
    selectedExternalPlans.reduce((acc, externalPlanId) => {
      const externalPlan = state.externalPlans.find(
        externalPlan => externalPlan.id === externalPlanId
      )
      return (
        acc +
        getExternalPlanTotal(externalPlan, selectedBenefitLevels[externalPlanId] || {})
      )
    }, 0) || 0

  const total = premium + visionDentalCost + latitudeCost + externalPlanCost
  const prices = {
    plan: toMoney(premium),
    planNumber: premium,
    dentalVision: toMoney(visionDentalCost),
    latitude: toMoney(latitudeCost),
    total: toMoney(total),
    bigTotal: toMoney(total + subscriptionFee),
    subscriptionFee: toMoney(subscriptionFee),
    subscriptionFeeNumber: subscriptionFee,
    externalPlan: toMoney(externalPlanCost)
  }

  return prices
}

export default updatePlanPrices
